import React, { useState } from "react";
import Axios from "axios";
import {
  antdAsyncMessageError,
  antdAsyncMessageSuccess,
} from "../../../../helpers/AsyncMessage";
import { Form, Input, Button, Select, Row, Col, Radio, DatePicker } from "antd";
import ModalSpecial from "../../../../components/Layout/Modals/ModalSpecial";
import { useDispatch } from "react-redux";
import { useMutation, useQuery } from "react-query";
import { setGlobalModal } from "../../../../redux/Actions/orderAction";
import { ButtonDelete } from "../../../../components/common/Buttons";
import { DebounceSelect } from "../../../../components/common";
import { IconEditBold, IconCloseBold } from "../../../../components/Layout/Icons";
import moment from "moment";
import { useSelector } from "react-redux";

const AssignSupplyDateModal = ({ orders }) => {
  const [form] = Form.useForm();
  const globalModal = useSelector((state) => state.orders.globalModal);
  const [orderRows, setOrderRows] = useState(
    orders
      .flatMap((order) => order.order_rows)
      .filter(
        (orderRow) =>
          globalModal.numbersArray.includes(orderRow.id) &&
          orderRow?.disabled_at === null
      )
  );
  const [supplierCode, setSupplierCode] = useState("");
  const dispatch = useDispatch();
  const { data: commentStates } = useQuery("commentStates", () =>
    Axios.get(
      "/api/v1/comment_states/search_by_type?[q][comment_type_eq]=comment_management"
    ).then((res) => res.data)
  );
  function transformProductData(product) {
    return {
      order_row_ids: [product.id],
      product_title: product.product_name || "Unknown Product",
      quantity: parseFloat(product.quantity) || 0,
    };
  }
  const supplierCodeFetchOptions = async (value) => {
    try {
      let api_url = `/api/v1/suppliers?page=1&per_page=9999999&q[rivile_supplier_code_null]=0&q[title_or_rivile_supplier_code_i_cont_any]=${value}`;

      const { data } = await Axios.get(api_url);
      const valArr = data?.data;
      return (
        valArr.map((e) => ({
          ...e,
          value: e.id,
          label: `${e.rivile_supplier_code} - ${e.title}`,
        })) || []
      );
    } catch (err) {
      errorHandler(err);
      return [];
    }
  };

  const mutationPOST = useMutation({
    mutationFn: (value) =>
      Axios.post(`api/v1/supplying_incomes/create_simple`, {
        products: orderRows.map(transformProductData),
        supplier_id: supplierCode,
        client_shipment_date: moment(value.client_shipment_date).format(
          "YYYY-MM-DD"
        ),
        comment_state_id: value.comment_type,
        comment_text: value.comment,
      }).then((res) => res.data),
    onSuccess: () => {
      onClose();
      antdAsyncMessageSuccess({ text: "Successfully created", key: "default" });
    },
    onError: antdAsyncMessageError,
  });

  const isWeekend = (date) => {
    const day = date.day();
    return day === 0 || day === 6;
  };

  const disabledDate = (current) => {
    const today = moment().startOf("day");
    return isWeekend(current) || current.isBefore(today);
  };
  const onClose = () => {
    dispatch(setGlobalModal(false, null, null));
  };

  const handleProductNameChange = (index, value) => {
    const newOrderRows = [...orderRows];
    newOrderRows[index].product_name = value;
    setOrderRows(newOrderRows);
  };

  const handleQuantityChange = (index, value) => {
    const newOrderRows = [...orderRows];
    newOrderRows[index].quantity = value;
    setOrderRows(newOrderRows);
  };

  const handleDelete = (index) => {
    const newOrderRows = orderRows.filter((_, i) => i !== index);
    setOrderRows(newOrderRows);
  };
  const [isEditing, setIsEditing] = useState(
    Array(orderRows.length).fill(false)
  );

  const groupedOrderRows = orderRows.reduce((acc, row) => {
    const { product_info } = row;
    if (!acc[product_info.id]) {
      acc[product_info.id] = { ...row, quantity: 0 };
    }
    acc[product_info.id].quantity += parseFloat(row.quantity) || 0;
    return acc;
  }, {});

  const renderDataTable = () => {
    return (
      <table style={{ backgroundColor: "#FBFBFB" }} className="table">
        <thead>
          <tr>
            <th>SKU</th>
            <th>Title</th>
            <th>Qty</th>
          </tr>
        </thead>
        <tbody>
          {Object.values(groupedOrderRows).map((item, index) => (
            <tr key={index}>
              <td>{item.product_reference}</td>
              <td>
                {isEditing[index] ? (
                  <div style={{ width: 180 }} className="d-flex flex-row">
                    <Input.TextArea
                      value={item.product_name}
                      onChange={(e) =>
                        handleProductNameChange(index, e.target.value)
                      }
                    />
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        const newIsEditing = [...isEditing];
                        newIsEditing[index] = false;
                        setIsEditing(newIsEditing);
                      }}
                    >
                      <IconCloseBold />
                    </div>
                  </div>
                ) : (
                  <div style={{ width: 180 }} className="d-flex flex-row">
                    {item.product_name}
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        const newIsEditing = [...isEditing];
                        newIsEditing[index] = true;
                        setIsEditing(newIsEditing);
                      }}
                    >
                      <IconEditBold />
                    </div>
                  </div>
                )}
              </td>
              <td>
                <div className="d-flex flex-row gap-5">
                  <Input
                    style={{ width: 55 }}
                    value={item.quantity}
                    onChange={(e) =>
                      handleQuantityChange(index, e.target.value)
                    }
                  />
                  <ButtonDelete onDelete={() => handleDelete(index)} />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <ModalSpecial
      style={{ width: 450 }}
      text={
        <span className="font-bold text-xl text-black">Assign supply date</span>
      }
      onClose={onClose}
    >
      <Form
        form={form}
        layout="vertical"
        name="basic"
        onFinish={(values) => {
          mutationPOST.mutate(values);
        }}
        autoComplete="off"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              style={{ marginBottom: 0 }}
              label="Dispatch supplier code"
              name="supplier_code"
              rules={[{ required: true, message: "Can't be empty" }]}
            >
              <DebounceSelect
                labelInValue={false}
                required={true}
                showSearch={true}
                value={supplierCode}
                placeholder={"Type to search"}
                fetchOptions={supplierCodeFetchOptions}
                onChange={(value) => {
                  setSupplierCode(value);
                }}
                style={{
                  width: "100%",
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              style={{ marginBottom: 0 }}
              label="Client shipment date"
              name="client_shipment_date"
              rules={[{ required: true, message: "Can't be empty" }]}
            >
              <DatePicker
                disabledDate={disabledDate}
                style={{ width: "100%" }}
                placeholder="Select"
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          style={{ marginBottom: 0 }}
          label="Comment type"
          name="comment_type"
          initialValue={4}
        >
          <Select
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {commentStates?.map((commentState) => (
              <Select.Option key={commentState.id} value={commentState.id}>
                {commentState.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Comment" name="comment">
          <Input.TextArea placeholder="Type in" />
        </Form.Item>
        <hr />
        {renderDataTable()}
        <Form.Item>
          <Button
            disabled={Object.values(groupedOrderRows)?.length === 0}
            className="w-100"
            type="primary"
            htmlType="submit"
            loading={mutationPOST.isLoading}
          >
            Save
          </Button>
        </Form.Item>
      </Form>
    </ModalSpecial>
  );
};

export default AssignSupplyDateModal;
